// Update search setting (searchSettings)
if(boostSDAppConfig?.searchSettings) {
  boostSDAppConfig.searchSettings.suggestionMobileStyle = 'style2';
}


/*********************** Remove the default section after loading the Boost AI grid ************************/

function removeDefaultSection() {
  const defaultSection = document.querySelector('.js-main-collection-section');
  if (defaultSection) defaultSection.remove();
}

/*********************** Custom JS for Boost AI Search & Discovery  ************************/

if (window.boostSDAppConfig) {
  window.boostSDAppConfig.integration =  Object.assign({wishlists: 'plus'}, window.boostSDAppConfig.integration || {});
  removeDefaultSection();
}

function onCreateElement(tag, classNamesArr, innerHTML) {
  const element = document.createElement(tag);
  if (classNamesArr.length) {
    classNamesArr.forEach(className => element.classList.add(className));
  }
  if (innerHTML) {
    element.innerHTML = innerHTML;
  }
  return element;
}

function waitForElement(selector, callback) {
  const observer = new MutationObserver((mutationsList, observer) => {
    const element = document.querySelector(selector);
    if (element) {
      observer.disconnect(); // Зупиняємо спостереження
      callback(element); // Викликаємо функцію
    }
  });

  // Спостерігаємо за змінами у всьому DOM
  observer.observe(document.body, { childList: true, subtree: true });
}

function getCollectionFullWidhtBanner() {
  let fullwidthBannerMarup = '';

  if(window.collectionFullWidhtBannerData){
    let isLink = false;
    let bannerClasses = ['boost-sd__collection-full-width-banner'];

    //Banner text
    let bannerTitle = window.collectionFullWidhtBannerData.collection_full_width_banner_title;
    let bannerText = window.collectionFullWidhtBannerData.collection_full_width_banner_text;

    //Banner text color
    let bannerTitleColor = window.collectionFullWidhtBannerData.collection_full_width_banner_title_color;
    let bannerTextColor = window.collectionFullWidhtBannerData.collection_full_width_banner_text_color;

    //Banner media
    let bannerDeskImage = window.collectionFullWidhtBannerData.collection_full_width_banner_desk_image;
    let bannerMobImage = window.collectionFullWidhtBannerData.collection_full_width_banner_mob_image;
    let bannerIcon1 = window.collectionFullWidhtBannerData.collection_full_width_banner_icon_1;
    let bannerIconLink1 = window.collectionFullWidhtBannerData.collection_full_width_banner_icon_link_1;
    let bannerIcon2 = window.collectionFullWidhtBannerData.collection_full_width_banner_icon_2;
    let bannerIconLink2 = window.collectionFullWidhtBannerData.collection_full_width_banner_icon_link_2;

    if(bannerIcon1 && bannerIconLink1 || bannerIcon2 && bannerIconLink2){
      isLink = true;
      bannerClasses.push('boost-sd__collection-full-width-banner--with-link');
    }

    if(bannerDeskImage){
      let html = `
        <div class="boost-sd__collection-full-width-banner__image">
          ${window.innerWidth <= 640 && bannerMobImage
            ? `<img src="${bannerMobImage}" alt="${bannerTitle}" />`
            : `<img src="${bannerDeskImage}" alt="${bannerTitle}" />`
          }
        </div>
        ${
          bannerTitle || bannerText
          ? ` <div class="boost-sd__collection-full-width-banner__content">
            ${bannerTitle ? `<div class="boost-sd__collection-full-width-banner__title" style="color: ${bannerTitleColor}">${bannerTitle}</div>` : ''}
            ${bannerText ? `<div class="boost-sd__collection-full-width-banner__text" style="color: ${bannerTextColor}">${bannerText}</div>` : ''}
          </div>`
          : ''
        }

        ${
          isLink
          ? `<div class="boost-sd__collection-full-width-banner__links">
            ${bannerIconLink1 && bannerIcon1
              ? `<a href="${bannerIconLink1}" class="boost-sd__collection-full-width-banner__link">
                <img src="${bannerIcon1}" alt="${bannerTitle}" />
                </a>`
              : ''
            }

            ${bannerIconLink2 && bannerIcon2
              ? `<a href="${bannerIconLink2}" class="boost-sd__collection-full-width-banner__link">
                <img src="${bannerIcon2}" alt="${bannerTitle}" />
                </a>`
              : ''
            }
          </div>`
          : ''
        }
      `;

      fullwidthBannerMarup = onCreateElement('div', bannerClasses, html);
    }
  }

  return fullwidthBannerMarup;
}

function getProductWeight(date) {
  return Array.from(date).map(m => {
    if (m.key == 'diamond-carats') {
      return `${m.value} ct`;
    }

    if (m.key == 'weight') {
      return `${m.value} ${m.value > 1 ? 'grams' : 'gram'}`;
    }
  })[0]
}

function setCollectionFullWidthBanner(productListEl) {
  let collectionFullWidhtBanner = getCollectionFullWidhtBanner();
  let productList = productListEl.querySelectorAll('.boost-sd__product-item');
  let productLength = productList.length;
  let afterElementInsetr = productList[5] || productList[productLength - 1];

  if(!afterElementInsetr) return;
  
  if(window.location.search.includes('page=1') || !window.location.search.includes('page=')){
    productListEl.querySelector('.boost-sd__collection-full-width-banner')?.remove();
    afterElementInsetr.insertAdjacentElement('afterend', collectionFullWidhtBanner);
  }
}

function setFilterHeader(date){
  if(!document.querySelector('.boost-sd__filter-header')){
    let filterWrapper = document.querySelector('.boost-sd__filter-tree-vertical');
    let filterHeader = onCreateElement('div', ['boost-sd__filter-header'], '');
    let closeFilterButton = filterWrapper.querySelector('.boost-sd__filter-tree-vertical-close-filter');
  
    filterHeader.appendChild(onCreateElement('span', ['boost-sd__filter-header-title'], 'Filter by'));
    closeFilterButton && filterHeader.appendChild(closeFilterButton);
    filterWrapper.insertBefore(filterHeader, filterWrapper.firstElementChild);
  }

  setFilterResultOnFilterHeader(date);
}

function setFilterResultOnFilterHeader(date){
  if(!date) return;
  let result = date.result.total_product;
  let filterTitle = document.querySelector('.boost-sd__filter-header .boost-sd__filter-header-title');

  if(!document.querySelector('.boost-sd__filter-header-title--result')){
    let resultEl = onCreateElement('span', ['boost-sd__filter-header-title--result'], `${result} Products`);
    filterTitle && filterTitle.appendChild(resultEl);
  }else{
    document.querySelector('.boost-sd__filter-header-title--result').innerHTML = `${result} Products`;
  }
}

function setClearAllButton(element){
  let filterWrapper = element;
  let insertToElement = onCreateElement('div', ['boost-sd__filter-tree-vertical-show-result-inner'], '');
  let originalClearAllButton = window.innerWidth <= 767
  ? element.querySelector('.boost-sd__filter-tree-vertical-mobile-toolbar .boost-sd__button--clear')
  : element.querySelector('.boost-sd__refine-by-vertical-refine-by .boost-sd__button--clear');

  let cloneOfClearAllButton = originalClearAllButton 
  ? originalClearAllButton.cloneNode(true) 
  : undefined;

  if(!filterWrapper.querySelector('.boost-sd__filter-tree-vertical-show-result-inner')){
    let filterResultWrapper = filterWrapper.querySelector('.boost-sd__filter-tree-vertical-show-result');
    let filterResultButton = filterWrapper.querySelector('.boost-sd__button--result');
    
    insertToElement && insertToElement.appendChild(filterResultButton);
    filterResultWrapper && filterResultWrapper.appendChild(insertToElement);
  }

  if(!cloneOfClearAllButton && filterWrapper.querySelector('.boost-sd__filter-tree-vertical-show-result-inner .boost-sd__button--clear')) {
    filterWrapper.querySelector('.boost-sd__filter-tree-vertical-show-result-inner .boost-sd__button--clear').remove();
    return;
  }

  if(!filterWrapper.querySelector('.boost-sd__filter-tree-vertical-show-result-inner .boost-sd__button--clear') && cloneOfClearAllButton){
    filterWrapper.querySelector('.boost-sd__filter-tree-vertical-show-result-inner').appendChild(cloneOfClearAllButton);

    cloneOfClearAllButton.addEventListener('click', () => filterWrapper.querySelector('.boost-sd__button--clear').click());
  }
}

window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
  (componentRegistry) => {
    componentRegistry.useModulePlugin("FilterAPI", {
      name: "FilterAPI plugin",
      apply(builder) {
        builder.on("methodFulfilled", "get", (payload) => {
          setFilterHeader(payload);
          waitForElement('.boost-sd__product-list', setCollectionFullWidthBanner);
          waitForElement('.boost-sd__filter-tree-vertical', setClearAllButton);
          return payload;
        });
      },
    });

    componentRegistry.useComponentPlugin('ProductList', {
      name: 'ProductListClass',
      enabled: true,
      apply: () => ({
        afterRender(element) {
          try {
            if (element) {
              let root_el = element.getRootElm();

              if(root_el.querySelector('.boost-sd__product-list')){
                let list_el = root_el.querySelector('.boost-sd__product-list');
  
                if(window.innerWidth > 1024 && window.innerWidth < 1300) {
                  if(list_el.classList.contains('boost-sd__product-list-grid--4-col')) {
                    list_el.classList.remove('boost-sd__product-list-grid--4-col');
                    list_el.classList.add('boost-sd__product-list-grid--3-col');
                  }
                }
              }
            }
          } catch (e) {
          }
        }
      })
    });

    componentRegistry.useComponentPlugin("ProductTitle", {
      name: "Custom product title",
      enabled: true,
      apply: () => ({
        afterRender(element) {
          try {
            if (element) {
              let productTitle = element.getRootElm();
              let h3 = document.createElement("h3");

              h3.setAttribute("style", productTitle.getAttribute("style"));
              h3.classList.add("boost-sd__product-title");
              h3.innerHTML = productTitle.innerHTML;

              productTitle.replaceWith(h3);
            }
          } catch (e) {}
        },
      }),
    });

    componentRegistry.useComponentPlugin("ProductItemWidget", {
      name: "Custom Product Buttons",
      enabled: true,
      apply: () => ({
        afterRender(element) {
          try {
            if (element) {
              let productCard = element.getRootElm();
              let productParameters = element.getParams();
              let productCardInfo = productCard.querySelector('.boost-sd__product-info');
              let productWeight = getProductWeight(productParameters.props.product.metafields);

              if(productWeight && !productCardInfo.querySelector('.boost-sd__product-weight')){
                productCardInfo.querySelector('.boost-sd__product-price').insertAdjacentElement('afterend', onCreateElement('div', ['boost-sd__product-weight'], productWeight));
              }
              
              if(productCardInfo.querySelector('.boost-sd__button') && !productCardInfo.querySelector('.boost-sd__buttons-wrapper')){
                let buttonsWrapperEl = productCardInfo.querySelector('.boost-sd__button').classList.contains('boost-sd__button--show-on-hover') 
                ? onCreateElement('div', ['boost-sd__buttons-wrapper','boost-sd__buttons-wrapper--show-on-hover'])
                : onCreateElement('div', ['boost-sd__buttons-wrapper']);

                productCardInfo.querySelector('.boost-sd__wishlist')?.classList.add('boost-sd__button','boost-sd__button--border','boost-sd__button--left','boost-sd__button--height-fit-content','boost-sd__button--full-width','boost-sd__button--show-on-hover','boost-sd__button--no-minwidth');

                let cardButtons = productCardInfo.querySelectorAll('.boost-sd__button');

                cardButtons.forEach(button => {
                  buttonsWrapperEl.appendChild(button);
                });

                productCardInfo.appendChild(buttonsWrapperEl);
              }
            }
          } catch (e) {}
        },
      }),
    });


    componentRegistry.useComponentPlugin("PaginationButton", {
      name: "Custom Product Buttons",
      enabled: true,
      apply: () => ({
        afterRender(element) {
          try {
            if (element) {
              let parameters = element.getParams();
              let buttom = element.getRootElm()

              if(parameters.props.text.includes('Previous') || parameters.props.text.includes('Previous Page')){
                buttom.style.display = 'none';
              }
            }
          } catch (e) {}
        },
      }),
    });
  }
]);